import { Form } from '@domain-group/suit-theme'

import useAgencyPortals from '@hooks/useAgencyPortals'

import { UseCampaignPortalModalPayload } from '@modals/EditCampaignPortalModal/hooks/useCampaignPortalModal'

import AgencyPortalOption from './AgencyPortalOption'

interface AgencyPortalSelectProps {
  campaignPortalModalPayload: UseCampaignPortalModalPayload,
  portalId: number,
}

const AgencyPortalSelect = (props: AgencyPortalSelectProps) => {
  const { campaignPortalModalPayload, portalId } = props

  const { campaignPortalFormPayload } = campaignPortalModalPayload || {}

  const {
    entityState: { outgoing_agent_id },
    handlers,
  } = campaignPortalFormPayload

  const { filteredAgencyPortals } = useAgencyPortals({
    filters: {
      portal_id: portalId,
    },
    requestOptions: {
      brand_group_portals: true,
    },
    performHttpRequests: !!portalId,
  })

  return (
    <Form.Field direction="column" label="Outgoing Agency ID" marginTop="medium">
      {/*
       // @ts-expect-error TS2322 */}
      <select name="outgoing_agent_id" value={outgoing_agent_id} {...handlers}>
        <option value="">Campaign Default</option>
        {filteredAgencyPortals.map(
          agencyPortal => <AgencyPortalOption agencyPortal={agencyPortal} key={agencyPortal.id} />,
        )}
      </select>
    </Form.Field>
  )
}

export default AgencyPortalSelect
